var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYieldsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3334V7.55566M12 15.3334C8.93175 15.3334 6.44444 17.8207 6.44444 20.889M12 15.3334C15.0682 15.3334 17.5556 17.8207 17.5556 20.889M5.33333 12.0001L4.22222 10.889M18.6667 12.0001L19.7778 10.889M2 20.889H22",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 20.889C8.66602 19.048 10.1584 17.5557 11.9993 17.5557C13.8403 17.5557 15.3327 19.048 15.3327 20.889",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2076 3.1458C17.7632 5.36802 17.5409 9.59025 12.2076 8.70136C11.652 6.66432 11.8743 2.70136 17.2076 3.1458Z",
    stroke: "#C0C9FF",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65373 3.1458C6.09818 5.36802 6.3204 9.59025 11.6537 8.70136C12.2093 6.66432 11.9871 2.70136 6.65373 3.1458Z",
    stroke: "#C0C9FF",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYieldsIcon);
export default __webpack_public_path__ + "static/media/yieldsIcon.660e54b1abbf9e5abe4ddc36e2943092.svg";
export { ForwardRef as ReactComponent };